import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';

const NO_BACK_ROUTES = ["/auth"];

const GlobalHomeButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (!NO_BACK_ROUTES.includes(location.pathname)) {
    return null;
  }

  const handleBack = () => {
    navigate('/');
  };

  return (
    
    <Tooltip title="Go Back">
    <IconButton
        onClick={handleBack}
        sx={{
        position: "fixed",
        top: "80px",
        left: "20px",
        zIndex: 9999,
        backgroundColor: "#ffffff",
        color: "#AD26BF",
        border: "1px solid #ccc",
        "&:hover": {
            backgroundColor: "#f0f0f0",
        },
        }}
    >
        <HomeIcon />
    </IconButton>
    </Tooltip>

  );
};

export default GlobalHomeButton;
